import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { useEffect } from "react";
export const PageAuthHub = () => {
    const delayForRedirect = () => {
        console.log("delayForRedirect==>", window.location.href);
        const getUrl = localStorage.getItem("URL_REDIRECT");
        UIStore.setState({ isLoading: true });
        setTimeout(() => {
            UIStore.setState({ isLoading: false });
            localStorage.removeItem("URL_REDIRECT");
            window.location.href = getUrl || "/";
        }, 1000);
    };
    useEffect(() => {
        delayForRedirect();
    }, []);

    return <></>;
};
